var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRiderCannotRide(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 65.737 65.737",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#F9423B",
    fillRule: "nonzero",
    stroke: "#3C3C3B"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.869.9C15.209.9.9 15.209.9 32.869c0 17.66 14.309 31.968 31.969 31.968 17.66 0 31.968-14.308 31.968-31.968S50.53.9 32.87.9zm0 57.75c-14.244 0-25.782-11.537-25.782-25.781 0-14.244 11.538-25.782 25.782-25.782s25.78 11.538 25.78 25.782-11.536 25.78-25.78 25.78z",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.869 45.619v-25h4.8l12.468 14.817V20.62h5.732v25h-4.765L26.601 30.488v15.13h-5.732z",
    strokeWidth: 1.5
  }))));
}
export default SvgRiderCannotRide;